import React, { useEffect, useState } from 'react';
import moment from 'moment';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import * as DatiFide from '../DatiFide';
import { BottoneAPI, Trad, Tipo, Mandanti } from '../components/';
import useReducerOnChange from "../hooks/ReducerOnChange";
import ChiamaWeb, { CChiamaWebParametri } from '../ChiamaWeb';
import { CData } from '../Data';

class CDatiPolizzaFide {
    public ID_FideAffidamento: number = 0;
    public ID_AnagBeneficiario: number = 0;
    public ATI: boolean = false;
    public EtichettaATI: string = "ATI";
    public MandantiJSON: Glob.DatiJSON = '[]';
    public Durata: number = 0;
    public LuogoEsecuzione: string = "";
    public DataSvincolo: Date = new Date(Date.now());
}

export const FideNuovo: React.FC<Glob.IRouteGlobaleProps> = (props) => {
    const [FideAffidamentoNuovo, setFideAffidamentoNuovo] = useReducerOnChange<DatiFide.CDatiFideAffidamento>({
        ...new DatiFide.CDatiFideAffidamento(),
        ID_AnagDa: Glob.GetSessione().ID_Anag
    });
    const [PolizzaNuovo, setPolizzaNuovo] = useReducerOnChange<Dati.CDatiPolizza>({
        ...new Dati.CDatiPolizza(),
        ID_TipoRamo: Glob.TipiRami_Fideiussioni,
        ID_AnagPOS: Glob.GetSessione().ID_Anag,
        CoAssicurazioneJSON: '[]',
    });

    const [DatiPolizzaNuovo, setDatiPolizzaNuovo] = useReducerOnChange<CDatiPolizzaFide>(new CDatiPolizzaFide());

    const [ATIVisibile, setATIVisibile] = useState(false);

    let EtichetteATI: Dati.TDictTipo = {};
    EtichetteATI["ATI"] = new Dati.CTipo("ATI", "ATI");
    EtichetteATI["RTI"] = new Dati.CTipo("RTI", "RTI");
    EtichetteATI["CostituendaATI"] = new Dati.CTipo("CostituendaATI", "CostituendaATI");
    EtichetteATI["CostituendoRTI"] = new Dati.CTipo("CostituendoRTI", "CostituendoRTI");

    function SetMenu(menu: number, variabili: { [D: string]: string }) {
        var M = Glob.GetMenu();
        M.Main = "Affidamento";
        M.ID_MenuMain = menu;
        M.VariabiliMenu = variabili;
        props.SetMenu(M);
    }
    useEffect(() => {
        if (!Glob.AzioneAbilitata("FideAffidamentoController", Glob.Scrittura)) {
            props.history.push("/ErroreAccesso");
            return;
        }
        SetMenu(0, {});
    }, []);

    function ApriPopupFideAffidamentoAnagA(): void {
        let Popup: Window | null = window.open("/anagrafica/0?Popup=true", "PopupFideAffidamentoAnagA", "width=1920,height=1080");
        if (Popup != null) {
            Popup.onbeforeunload = function() {
                if (Popup != null) {
                    let PopupID_Anag = Popup.document.getElementById("PopupID_Anag") as HTMLInputElement | null;
                    if (PopupID_Anag != null && PopupID_Anag.value != null) {
                        setFideAffidamentoNuovo({ Type: "OnChangeFromValue", Name: "ID_AnagA", Value: Number(PopupID_Anag.value) });
                    }
                }
            };
        }
    }

    function ApriPopupPolizzaAnagBeneficiario(): void {
        let Popup: Window | null = window.open("/anagrafica/0?Popup=true", "PopupPolizzaAnagBeneficiario", "width=1920,height=1080");
        if (Popup != null) {
            Popup.onbeforeunload = function() {
                if (Popup != null) {
                    let PopupID_Anag = Popup.document.getElementById("PopupID_Anag") as HTMLInputElement | null;
                    if (PopupID_Anag != null && PopupID_Anag.value != null) {
                        setDatiPolizzaNuovo({ Type: "OnChangeFromValue", Name: "ID_AnagBeneficiario", Value: Number(PopupID_Anag.value) });
                    }
                }
            };
        }
    }

    function FideAffidamentoNuovoAttivo() {
        return FideAffidamentoNuovo.ID_AnagA > 0 && FideAffidamentoNuovo.ID_AnagDa > 0 && FideAffidamentoNuovo.ListaBinderJSON != '[]';
    }

    function OnInvioFideAffidamentoNuovo(sender: BottoneAPI): Dati.CIngrAPI<DatiFide.CDatiFideAffidamento> {
        var Ingr = new Dati.CIngrAPI<DatiFide.CDatiFideAffidamento>();
        Ingr.Dato = FideAffidamentoNuovo;
        return Ingr;
    }

    function OnClickFideAffidamentoNuovo(sender: BottoneAPI, dati: DatiFide.CRisAPIDatoTipi_FideAffidamento) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto));
        }
        else {
            props.history.push("/anagrafica/" + FideAffidamentoNuovo.ID_AnagA + "/fideaffidamento/" + dati.ID_Chiave);
        }
    }

    function PolizzaNuovoAttivo() {
        if (DatiPolizzaNuovo.ATI) {
            let Mandanti: Dati.CDatoMandante[] = JSON.parse(DatiPolizzaNuovo.MandantiJSON);
            if (Mandanti.length == 0) return false;
            let QuotaMandataria: number = 100;
            let QuotaMandanteMax: number = 0;
            for (let M: number = 0; M < Mandanti.length; M++) {
                QuotaMandataria -= Mandanti[M].Quota;
                if (QuotaMandanteMax < Mandanti[M].Quota) {
                    QuotaMandanteMax = Mandanti[M].Quota;
                }
                //if (Mandanti[M].RagioneSociale.trim().length == 0 || Mandanti[M].PartitaIVA.trim().length != 11)
                if (Mandanti[M].ID_Anag == 0) {
                    return false;
                }
            }

            // if (QuotaMandataria < QuotaMandanteMax) {
            //     return false;
            // }
        }

        return PolizzaNuovo.ID_AnagContraente > 0
            && PolizzaNuovo.ID_AnagPOS > 0
            && PolizzaNuovo.ID_TipoRamo > 0
            && PolizzaNuovo.ID_TipoProdotto > 0
            && PolizzaNuovo.CoAssicurazioneJSON != "[]"
            && DatiPolizzaNuovo.ID_AnagBeneficiario > 0
            && DatiPolizzaNuovo.ID_FideAffidamento > 0;
    }

    function OnInvioPolizzaNuovo(sender: BottoneAPI): Dati.CIngrAPI<Dati.CDatiPolizza> {
        var Ingr = new Dati.CIngrAPI<Dati.CDatiPolizza>();
        Ingr.Dato = PolizzaNuovo;
        DatiPolizzaNuovo.LuogoEsecuzione = "Vedasi oggetto garanzia";
        DatiPolizzaNuovo.Durata = ((PolizzaNuovo.ID_TipoProdotto == Glob.TipoProdotto_CauzioneProvvisoriaLavori) || (PolizzaNuovo.ID_TipoProdotto == Glob.TipoProdotto_CauzioneProvvisoriaForniture) || (PolizzaNuovo.ID_TipoProdotto == Glob.TipoProdotto_CauzioneProvvisoriaServizi)) ? 180 : 0,
            DatiPolizzaNuovo.DataSvincolo = (new CData(moment(PolizzaNuovo.DataEffetto).toDate(), true)).AddGiorni(DatiPolizzaNuovo.Durata).Data;
        PolizzaNuovo.DataFine = DatiPolizzaNuovo.DataSvincolo;
        Ingr.Dato.DatiPolizza = JSON.stringify(DatiPolizzaNuovo);

        return Ingr;
    }

    function OnClickPolizzaNuovo(sender: BottoneAPI, dati: Dati.CRisAPIDatoTipiInfo_Polizza) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto));
        }
        else {
            props.history.push("/anagrafica/" + PolizzaNuovo.ID_AnagContraente + "/fideaffidamento/" + DatiPolizzaNuovo.ID_FideAffidamento + "/fidepolizza/" + dati.ID_Chiave);
        }
    }

    function OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {
        Glob.InfoModaleError(Trad.Trad("ERRORE"), errore.message);
    }

    useEffect(() => {
        setPolizzaNuovo({ Type: "OnChangeFromValue", Name: "CoAssicurazioneJSON", Value: JSON.stringify([]) });

        const Param: CChiamaWebParametri = {
            URL: "/api/polizza/GetFideBinderProdottoSottoscritto?id_FideAffidamento=" + DatiPolizzaNuovo.ID_FideAffidamento + "&id_TipoProdotto=" + PolizzaNuovo.ID_TipoProdotto + "&dataEffetto=" + moment().utc().format(),
            OnRis: (sender: ChiamaWeb, dati: Dati.CRisAPISemplice<string>) => {
                //private CoAssicurazioneSingola(binderProdotto: string) {
                if (dati.Dato.length > 0) {
                    let BP: Dati.CDatoBinderProdottoCoAssicurazione[] = JSON.parse(dati.Dato);
                    if (BP.length == 1) {
                        let CoAss = new Dati.CDatoCoAssicurazione();
                        CoAss.Delegataria = true;
                        CoAss.Quota = 100;
                        CoAss.ID_Anag = BP[0].ID_AnagCompagnia;
                        CoAss.ID_Binder = BP[0].ID_Binder;
                        CoAss.ID_BinderCompagnia = BP[0].ID_BinderCompagnia;
                        setPolizzaNuovo({ Type: "OnChangeFromValue", Name: "CoAssicurazioneJSON", Value: JSON.stringify([CoAss]) });
                    }
                    else {
                        setPolizzaNuovo({ Type: "OnChangeFromValue", Name: "CoAssicurazioneJSON", Value: JSON.stringify(BP) });
                    }
                }
                //}
            }
        };
        new ChiamaWeb().Chiama(Param);

        //setATIVisibile(PolizzaNuovo.ID_TipoProdotto == 4 || PolizzaNuovo.ID_TipoProdotto == 17 || PolizzaNuovo.ID_TipoProdotto == 18);
        setATIVisibile(true);
    }, [PolizzaNuovo.ID_TipoProdotto]);

    useEffect(() => {
        setDatiPolizzaNuovo({ Type: "OnChangeFromValue", Name: "ID_FideAffidamento", Value: 0 });
        setDatiPolizzaNuovo({ Type: "OnChangeFromValue", Name: "ID_TipoProdotto", Value: 0 });
    }, [PolizzaNuovo.ID_AnagContraente]);

    return (
        <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon">
                            <i className="fa fa-pencil-alt"></i>
                        </span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad("Nuovo") + "..."}
                        </h3>
                    </div>
                </div>
            </div>
            <div className="kt-portlet__head">
                <h3 className="kt-portlet__head-label">
                    {Trad.Trad("Affidamento")}
                </h3>
            </div>
            <form className="kt-form login-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                <div className="kt-portlet__body">
                    <div className="form-group kt-form login-form__group row">
                        <div className="col-lg-6">
                            <label>{Trad.Trad("Affidatario")}</label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" Campo="ID_AnagDa" ID_Chiave={FideAffidamentoNuovo.ID_AnagDa} OnAggiorna={(e, v) => setFideAffidamentoNuovo({ Type: "OnChangeFromValue", Name: e, Value: v })} Disabilitato={!Glob.AzioneAbilitata("FideAffidamentoID_AnagDa", 2)} TradValori LinkSelezione="/anagrafica/" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <label>{Trad.Trad("Affidato")}</label><a href="/anagrafica/0" onClick={(e) => { e.preventDefault(); ApriPopupFideAffidamentoAnagA() }} className="arrow"> <i className="fa fa-plus" /> </a>
                            <div className="kt-input-icon kt-input-icon--right">
                                <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" Campo="ID_AnagA" ID_Chiave={FideAffidamentoNuovo.ID_AnagA} OnAggiorna={(e, v) => setFideAffidamentoNuovo({ Type: "OnChangeFromValue", Name: e, Value: v })} TradValori LinkSelezione="/anagrafica/" />
                            </div>
                        </div>
                    </div>
                    <div className="form-group kt-form login-form__group row">
                        <div className="col-lg-12">
                            <label>{Trad.Trad("ListaBinder")}</label>
                            <Tipo SceltaMultipla URL={"/api/FideAffidamento/ListaBinderDisponibili?id_AnagDa=" + FideAffidamentoNuovo.ID_AnagDa + "&dateRelease=" + moment().utc().format()}
                                Campo={"ListaBinderJSON"}
                                ID_ChiaveString={FideAffidamentoNuovo.ListaBinderJSON} OnAggiorna={(e, v) => setFideAffidamentoNuovo({ Type: "OnChangeFromValue", Name: e, Value: v })}
                                TradValori={false} />
                        </div>
                    </div>
                    <div className="kt-portlet__foot kt-portlet__foot--fit">
                        <div className="kt-form login-form__actions kt-form login-form__actions--right">
                            <div className="row">
                                <div className="col kt-form__actions kt-form__actions--right">
                                    <BottoneAPI Default Testo={Trad.Trad("Nuovo")} URL="/api/fideaffidamento/" Metodo="POST" OnInvio={(s) => OnInvioFideAffidamentoNuovo(s)} OnClick={(s, d) => OnClickFideAffidamentoNuovo(s, d)} OnErrore={(s, e) => OnErroreBottoneAPI(s, e)} Attivo={FideAffidamentoNuovoAttivo()} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div className="kt-portlet__head">
                <h3 className="kt-portlet__head-label">
                    {Trad.Trad("Polizza")}
                </h3>
            </div>
            <form className="kt-form login-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                <div className="kt-portlet__body">
                    <div className="form-group kt-form login-form__group row">
                        <div className="col-lg-6">
                            <label>{Trad.Trad("POS")}</label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" Campo="ID_AnagPOS" ID_Chiave={PolizzaNuovo.ID_AnagPOS} OnAggiorna={(e, v) => setPolizzaNuovo({ Type: "OnChangeFromValue", Name: e, Value: v })} Disabilitato={!Glob.AzioneAbilitata("FideAffidamentoID_AnagDa", 2)} TradValori LinkSelezione="/anagrafica/" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <label>{Trad.Trad("Contraente")}</label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" Campo="ID_AnagContraente" ID_Chiave={PolizzaNuovo.ID_AnagContraente} OnAggiorna={(e, v) => setPolizzaNuovo({ Type: "OnChangeFromValue", Name: e, Value: v })} TradValori LinkSelezione="/anagrafica/" />
                            </div>
                        </div>
                    </div>
                    <div className="form-group kt-form login-form__group row">
                        <div className="col-lg-7">
                            <label>{Trad.Trad("Affidamento")}</label>
                            <div className="kt-input-icon kt-input-icon--right">
                                <Tipo URL={"/api/FideAffidamento/ListaAffidamentiAnagrafica?sottoscritti=true&ID_AnagA=" + PolizzaNuovo.ID_AnagContraente} Campo="ID_FideAffidamento" ID_Chiave={DatiPolizzaNuovo.ID_FideAffidamento} OnAggiorna={(e, v) => setDatiPolizzaNuovo({ Type: "OnChangeFromValue", Name: e, Value: v })} TradValori />
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <label>{Trad.Trad("Prodotto")}</label>
                            <Tipo URL={"/api/Tipi/Tipo?tabella=TipiProdottiFide&campo=TipoProdotto&parametri=" + DatiPolizzaNuovo.ID_FideAffidamento} Campo="ID_TipoProdotto" ID_Chiave={PolizzaNuovo.ID_TipoProdotto} OnAggiorna={(e, v) => setPolizzaNuovo({ Type: "OnChangeFromValue", Name: e, Value: v })} />
                        </div>
                        <div className="col-lg-2">
                            {ATIVisibile &&
                                <span className="kt-switch kt-switch--outline kt-switch--icon kt-switch--success">
                                    <div><label className="col-form-label">{Trad.Trad("ATI")}</label></div>
                                    <label>
                                        <input type="Checkbox" checked={DatiPolizzaNuovo.ATI} id={"ATI"} name={"ATI"} onChange={(e) => setDatiPolizzaNuovo({ Type: "OnChangeFromForm", Target: e.currentTarget })} />
                                        <span></span>
                                    </label>
                                </span>
                            }
                        </div>
                    </div>
                    {DatiPolizzaNuovo.ATI &&
                        <div className="form-group kt-form login-form__group row">
                            <div className="col-lg-2">
                                <div><label className="col-form-label">{Trad.Trad("EtichettaATI")}</label></div>
                                <label>
                                    <Tipo Campo="EtichettaATI" ID_ChiaveString={DatiPolizzaNuovo.EtichettaATI} OnAggiorna={(e, v) => setDatiPolizzaNuovo({ Type: "OnChangeFromValue", Name: e, Value: v })} TradValori Dati={EtichetteATI} />
                                </label>
                            </div>
                            <div className="col-lg-10">
                                <Mandanti ColonnaCapogruppo={false} Id="MandantiJSON" Name="MandantiJSON" Value={DatiPolizzaNuovo.MandantiJSON} OnChange={(e, v) => setDatiPolizzaNuovo({ Type: "OnChangeFromHybrid", NameEvent: e, Value: v })} />
                            </div>
                        </div>
                    }
                    <div className="form-group kt-form login-form__group row">
                        <div className="col-lg-12">
                            <label>{Trad.Trad("Beneficiario")}</label><a href="/anagrafica/0" onClick={(e) => { e.preventDefault(); ApriPopupPolizzaAnagBeneficiario() }} className="arrow"> <i className="fa fa-plus" /> </a>
                            <div className="kt-input-icon kt-input-icon--right">
                                <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" Campo="ID_AnagBeneficiario" ID_Chiave={DatiPolizzaNuovo.ID_AnagBeneficiario} OnAggiorna={(e, v) => setDatiPolizzaNuovo({ Type: "OnChangeFromValue", Name: e, Value: v })} TradValori LinkSelezione="/anagrafica/" />
                            </div>
                        </div>
                    </div>
                    <div className="kt-portlet__foot kt-portlet__foot--fit">
                        <div className="kt-form login-form__actions kt-form login-form__actions--right">
                            <div className="row">
                                <div className="col kt-form__actions kt-form__actions--right">
                                    <BottoneAPI Default Testo={Trad.Trad("Nuovo")} URL="/api/polizza/salvapolizza" Metodo="POST" OnInvio={(s) => OnInvioPolizzaNuovo(s)} OnClick={(s, d) => OnClickPolizzaNuovo(s, d)} OnErrore={(s, e) => OnErroreBottoneAPI(s, e)} Attivo={PolizzaNuovoAttivo()} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/form/FideNuovo.tsx